// extracted by mini-css-extract-plugin
module.exports = {"OverView":"OverViewNew_OverView__gHQxd"};